import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dynamic-select"
export default class extends Controller {
  static targets = ["parent", "child"]

  connect() {
    this.childTargets.forEach(childTarget => {
      childTarget.clone = childTarget.cloneNode(true)
    })

    this.updateChild()
  }

  change() {
    this.updateChild()
  }

  updateChild() {
    const parentSelectedOptions = Array.from(this.parentTarget.selectedOptions || [])
      .map(selectedOption => selectedOption.text)

    this.childTargets.forEach(childTarget => {
      const childOptions = ['<option value=""></option>']
      parentSelectedOptions.forEach(childGroupLabel => {
        const childGroup = childTarget.clone.querySelector(`optgroup[label='${childGroupLabel}']`)
        childOptions.push(childGroup.outerHTML)
      })

      childTarget.innerHTML = childOptions.join('')
    })
  }
}
